import React, { useState } from 'react';
import { updateOrderApi } from '../../utils/orderApi';
import { getOrderId } from './orderUtils';
import '../css/Category.css';

const OrderEdit = ({ editItem, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    UserId: editItem.UserId ?? editItem.userId ?? '',
    AddressId: editItem.AddressId ?? editItem.addressId ?? '',
    CartId: editItem.CartId ?? editItem.cartId ?? '',
    OrderNumber: editItem.OrderNumber ?? editItem.orderNumber ?? '',
    OrderStatus: editItem.OrderStatus ?? editItem.orderStatus ?? 'Ordered',
    PaymentStatus: editItem.PaymentStatus ?? editItem.paymentStatus ?? 'Pending',
    SubTotal: editItem.SubTotal ?? editItem.subTotal ?? 0,
    DiscountAmount: editItem.DiscountAmount ?? editItem.discountAmount ?? 0,
    ShippingAmount: editItem.ShippingAmount ?? editItem.shippingAmount ?? 0,
    TaxAmount: editItem.TaxAmount ?? editItem.taxAmount ?? 0,
    TotalAmount: editItem.TotalAmount ?? editItem.totalAmount ?? 0,
    Notes: editItem.Notes ?? editItem.notes ?? '',
  });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setFormError(null);
    try {
      await updateOrderApi({
        OrderId: Number(getOrderId(editItem)),
        UserId: Number(form.UserId),
        AddressId: Number(form.AddressId),
        CartId: form.CartId ? Number(form.CartId) : null,
        OrderNumber: form.OrderNumber,
        OrderStatus: form.OrderStatus,
        PaymentStatus: form.PaymentStatus,
        SubTotal: Number(form.SubTotal) || 0,
        DiscountAmount: Number(form.DiscountAmount) || 0,
        ShippingAmount: Number(form.ShippingAmount) || 0,
        TaxAmount: Number(form.TaxAmount) || 0,
        TotalAmount: Number(form.TotalAmount) || 0,
        Notes: form.Notes.trim() || null,
      });
      onSuccess('Order updated successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cat-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cat-modal" style={{ maxWidth: 640 }}>
        <div className="cat-modal-header">
          <h5>Edit Order #{getOrderId(editItem)}</h5>
          <button type="button" className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="cat-modal-body">
          {formError && <div className="alert alert-danger py-2 mb-3">{formError}</div>}
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Order Number</label>
              <input className="form-control" name="OrderNumber" value={form.OrderNumber} onChange={handleChange} />
            </div>
            <div className="col-md-3">
              <label className="form-label">User ID</label>
              <input className="form-control" name="UserId" value={form.UserId} onChange={handleChange} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Address ID</label>
              <input className="form-control" name="AddressId" value={form.AddressId} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Order Status</label>
              <input className="form-control" name="OrderStatus" value={form.OrderStatus} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Payment Status</label>
              <input className="form-control" name="PaymentStatus" value={form.PaymentStatus} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Total Amount</label>
              <input className="form-control" name="TotalAmount" value={form.TotalAmount} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label">Notes</label>
              <textarea className="form-control" name="Notes" value={form.Notes} onChange={handleChange} rows={2} />
            </div>
          </div>
        </div>
        <div className="cat-modal-footer">
          <button type="button" className="btn btn-light me-2" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderEdit;
